import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import * as moment from "moment"
import { SyncReceiptVouchers, SyncSalesVouchers } from "../sync/vouchers"
import hash from "object-hash"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetSalesVouchers(startDate, endDate) {

    console.log("GetSalesVouchers", startDate, endDate)
    let fromDate = moment(startDate).format("YYYYMMDD")
    let toDate = moment(endDate).format("YYYYMMDD")
    let _salesVoucherGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-sales-voucher-types`)) || []
    let salesVoucherGrps = _salesVoucherGrps?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHERTYPE || []
    if (!(salesVoucherGrps instanceof Array)) {
        salesVoucherGrps = [salesVoucherGrps]
    }

    let salesVoucherTypes = salesVoucherGrps.map((grp) => grp?._attributes?.NAME)

    salesVoucherTypes.push("Sales")

    let alterId = parseInt(window.localStorage.getItem(`tally-${TallyConfig.company}-vchAltId`)) || 0
    
    let filter = salesVoucherTypes.map((type) => `$VoucherTypeName='${type}'`).join(" OR ")

    filter = filter + ` AND $alterid &gt; ${alterId}`

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>Export</TALLYREQUEST>
                <TYPE>Collection</TYPE>
                <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                        <SVFROMDATE TYPE="Date">${fromDate}</SVFROMDATE>
                        <SVTODATE TYPE="Date">${toDate}</SVTODATE>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                    </STATICVARIABLES>
                    <TDL>
                        <TDLMESSAGE>
                            <COLLECTION NAME="Collection of Ledgers" ISMODIFY="No">
                                <TYPE>Voucher</TYPE>
                                <FETCH>
                                    GUID,ALTERID,MASTERID,ISOPTIONAL,ISDELETED,ISCANCELLED,DATE,REFERENCEDATE,VOUCHERTYPENAME,VOUCHERNUMBER,REFERENCE,NARRATION,PARTYNAME,PARTYLEDGERNAME,ENTEREDBY,EFFECTIVEDATE,COSTCENTRENAME,AUTOCOSTLEVEL,PARTYGSTIN,CMPGSTIN,GSTREGISTRATION,CMPGSTSTATE,BILLOFLADINGNO,BILLOFLADINGDATE,BASICSHIPVESSELNO,PLACEOFSUPPLY,BASICSHIPPEDBY,BASICSHIPDOCUMENTNO,BASICFINALDESTINATION,BASICORDERTERMS.LIST,BASICDUEDATEOFPYMT,BASICORDERREF,ISPOSTDATED,HASCASHFLOW,ISINVOICE,ISCOSTCENTRE,PRICELEVEL,HASDISCOUNTS,ISVOID,ISONHOLD,ISDEEMEDPOSITIVE,ALLLEDGERENTRIES.LIST,LEDGERENTRIES.LIST,ALLINVENTORYENTRIES.LIST,INVENTORYENTRIES.LIST,BASICBUYERADDRESS.LIST,BASICBUYERNAME,CONSIGNEECSTNUMBER,CONSIGNEEGSTIN,CONSIGNEEPINCODE,ADDRESS.LIST,BUYERSCSTNUMBER,BASICBUYERSSALESTAXNO,TRADERCONSVATTINNO.LIST,PARTYPINCODE,VOUCHERDESTINATIONGODOWN,VOUCHERSOURCEGODOWN,INVOICEDELNOTES.LIST,CATEGORYENTRY.LIST,CATEGORYALLOCATIONS.LIST,INVENTORYENTRIESIN.LIST,INVENTORYENTRIESOUT.LIST,INVOICEORDERLIST.LIST,EWAYBILLDETAILS.LIST,IRN,IRNACKNO,IRNACKDATE,IRNQRCODE,IRNCANCELLED
                                </FETCH>
                                <FILTERS>AlterId</FILTERS>
                            </COLLECTION>
                            <SYSTEM TYPE="FORMULAE" NAME="AlterId">${filter}</SYSTEM>
                        </TDLMESSAGE>
                    </TDL>
                </DESC>
            </BODY>
        </ENVELOPE>

    `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHER){
                return {
                    change: false,
                    status: true
                }
            }
            await SyncSalesVouchers(jsonData, startDate, endDate)

            return {
                change: true,
                status: true
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetReceiptVouchers(startDate, endDate) {

    let fromDate = moment(startDate).format("YYYYMMDD")
    let toDate = moment(endDate).format("YYYYMMDD")

    let _receiptVoucherGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-receipt-voucher-types`)) || []
    let receiptVoucherGrps = _receiptVoucherGrps?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHERTYPE || []
    if (!(receiptVoucherGrps instanceof Array)) {
        receiptVoucherGrps = [receiptVoucherGrps]
    }

    let receiptVoucherTypes = receiptVoucherGrps.map((grp) => grp?._attributes?.NAME)

    receiptVoucherTypes.push("Receipt")

    let alterId = parseInt(window.localStorage.getItem(`tally-${TallyConfig.company}-vchAltId`)) || 0
    
    let filter = receiptVoucherTypes.map((type) => `$VoucherTypeName='${type}'`).join(" OR ")

    filter = filter + ` AND $alterid &gt; ${alterId}`

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>Export</TALLYREQUEST>
                <TYPE>Collection</TYPE>
                <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                        <SVFROMDATE TYPE="Date">${fromDate}</SVFROMDATE>
                        <SVTODATE TYPE="Date">${toDate}</SVTODATE>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                    </STATICVARIABLES>
                    <TDL>
                        <TDLMESSAGE>
                            <COLLECTION NAME="Collection of Ledgers" ISMODIFY="No">
                                <TYPE>Voucher</TYPE>
                                <FETCH>
                                    GUID,ALTERID,MASTERID,ISOPTIONAL,ISDELETED,ISCANCELLED,DATE,REFERENCEDATE,VOUCHERTYPENAME,VOUCHERNUMBER,REFERENCE,NARRATION,PARTYNAME,PARTYLEDGERNAME,ENTEREDBY,EFFECTIVEDATE,COSTCENTRENAME,AUTOCOSTLEVEL,PARTYGSTIN,CMPGSTIN,GSTREGISTRATION,CMPGSTSTATE,BILLOFLADINGNO,BILLOFLADINGDATE,BASICSHIPVESSELNO,PLACEOFSUPPLY,BASICSHIPPEDBY,BASICSHIPDOCUMENTNO,BASICFINALDESTINATION,BASICORDERTERMS.LIST,BASICDUEDATEOFPYMT,BASICORDERREF,ISPOSTDATED,HASCASHFLOW,ISINVOICE,ISCOSTCENTRE,PRICELEVEL,HASDISCOUNTS,ISVOID,ISONHOLD,ISDEEMEDPOSITIVE,ALLLEDGERENTRIES.LIST,LEDGERENTRIES.LIST,ALLINVENTORYENTRIES.LIST,INVENTORYENTRIES.LIST,BASICBUYERADDRESS.LIST,BASICBUYERNAME,CONSIGNEECSTNUMBER,CONSIGNEEGSTIN,CONSIGNEEPINCODE,ADDRESS.LIST,BUYERSCSTNUMBER,BASICBUYERSSALESTAXNO,TRADERCONSVATTINNO.LIST,PARTYPINCODE,VOUCHERDESTINATIONGODOWN,VOUCHERSOURCEGODOWN,INVOICEDELNOTES.LIST,CATEGORYENTRY.LIST,CATEGORYALLOCATIONS.LIST,INVENTORYENTRIESIN.LIST,INVENTORYENTRIESOUT.LIST,INVOICEORDERLIST.LIST,EWAYBILLDETAILS.LIST,IRN,IRNACKNO,IRNACKDATE,IRNQRCODE,IRNCANCELLED
                                </FETCH>
                                <FILTERS>AlterId</FILTERS>
                            </COLLECTION>
                            <SYSTEM TYPE="FORMULAE" NAME="AlterId">${filter}</SYSTEM>
                        </TDLMESSAGE>
                    </TDL>
                </DESC>
            </BODY>
        </ENVELOPE>

    `


    data = xmlFormatter(data)
    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHER){
                return {
                    change: false,
                    status: true
                }
            }

            await SyncReceiptVouchers(jsonData, startDate, endDate)

            return {
                change: true,
                status: true
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetSalesVoucherTypes() {

    let data = `
        <ENVELOPE Action="">
            <HEADER>
            <VERSION>1</VERSION>
            <TALLYREQUEST>EXPORT</TALLYREQUEST>
            <TYPE>COLLECTION</TYPE>
            <ID>CUSTOMVOUCHERTYPECOL</ID>
            </HEADER>
            <BODY>
            <DESC>
                <STATICVARIABLES>
                    <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                </STATICVARIABLES>
                <TDL>
                <TDLMESSAGE>
                    <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="CUSTOMVOUCHERTYPECOL">
                    <TYPE>VOUCHERTYPE</TYPE>
                    <NATIVEMETHOD>*</NATIVEMETHOD>
                    <FILTERS>filter</FILTERS>
                    </COLLECTION>
                    <SYSTEM TYPE="Formulae" NAME="filter">$Parent=Sales</SYSTEM>
                </TDLMESSAGE>
                </TDL>
            </DESC>
            </BODY>
      </ENVELOPE>
    
        `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            window.localStorage.setItem(`tally-${TallyConfig.company}-sales-voucher-types`, JSON.stringify(jsonData))

            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetReceiptVoucherTypes() {

    let data = `
        <ENVELOPE Action="">
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>EXPORT</TALLYREQUEST>
                <TYPE>COLLECTION</TYPE>
                <ID>CUSTOMVOUCHERTYPECOL</ID>
            </HEADER>
            <BODY>
            <DESC>
                <STATICVARIABLES>
                    <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                </STATICVARIABLES>
                <TDL>
                    <TDLMESSAGE>
                        <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="CUSTOMVOUCHERTYPECOL">
                            <TYPE>VOUCHERTYPE</TYPE>
                            <NATIVEMETHOD>*</NATIVEMETHOD>
                        <FILTERS>filter</FILTERS>
                        </COLLECTION>
                        <SYSTEM TYPE="Formulae" NAME="filter">$Parent=Receipt</SYSTEM>
                    </TDLMESSAGE>
                </TDL>
            </DESC>
            </BODY>
        </ENVELOPE>
        
        `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            window.localStorage.setItem(`tally-${TallyConfig.company}-receipt-voucher-types`, JSON.stringify(jsonData))

            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}